<div class="new-case-modal">
    <app-modal-dialog [configuration]="modalDialogConfiguration" (closeModalEvent)="closeModalEvent($event)">
      <span class="main-section">{{'SMS is now sent to the patient. When the patient has filled out the form and submitted the data, then the case will be shown in the list of draft cases' | translate}}</span>
    </app-modal-dialog>
</div>
